import React from "react";
import { useState } from "react";

export default function Branding() {
  const steps = [
    {
      title: "Identifying your target audience",
      description:
        "We identify the target customers for your brand through research on demographics, behaviors, and preferences.",
      bgColor: "bg-blue-200",
    },
    {
      title: "Competitor Analysis & User Research",
      description:
        "We gather insights into the company industry, competitors, and market trends through extensive research.",
      bgColor: "bg-yellow-200",
    },
    {
      title: "Brand Model and Strategy",
      description:
        "Our team develops your brand personality, positioning, and branding strategy based on research findings.",
      bgColor: "bg-red-200",
    },
    {
      title: "Design Approach",
      description:
        "The creative team determines the overall aesthetic, color palette, typography, and imagery style for your brand.",
      bgColor: "bg-teal-200",
    },
    {
      title: "Brand Guidelines and Launch",
      description:
        "Finally, we develop comprehensive guidelines for consistent brand application, followed by an internal and external launch.",
      bgColor: "bg-gray-200",
    },
  ];
  const services = [
    {
      title: "Brand Identity Design",
      description:
        "Your brand identity is your visual fingerprint. It’s how customers recognize and remember your brand. A weak identity can cost you business. We can help you design a distinctive identity that makes you stand out and stick in customers' minds.",
      image: "https://placehold.co/600x400?text=Brand+Identity+Design",
      alt: "A person sketching brand identity designs on a notebook",
    },
    {
      title: "Corporate Identity Design",
      description:
        "Corporate identity is how the world sees your business. It creates a professional, unified look across all touchpoints. We develop robust corporate identity systems that build credibility and help you make a lasting impression.",
      image: "https://placehold.co/600x400?text=Corporate+Identity+Design",
      alt: "A desk with corporate identity design elements",
    },
    {
      title: "Brand Strategy",
      description:
        "Brand strategy shapes your brand's future. It guides all your branding and marketing efforts. Without a proper brand strategy, you risk losing direction. We create focused strategies that align your goals with your customers' needs.",
      image: "https://placehold.co/600x400?text=Brand+Strategy",
      alt: "A desk with brand strategy elements",
    },
    {
      title: "Motion Graphics Design",
      description:
        "Motion graphics bring your brand to life. They capture attention and explain complex ideas simply. We create engaging animations that make your message memorable and shareable across digital platforms.",
      image: "https://placehold.co/600x400?text=Motion+Graphics+Design",
      alt: "Motion graphics design elements",
    },
    {
      title: "Graphic Design",
      description:
        "Your brand's graphic design is your silent salesperson. It communicates your brand's value instantly. We create designs that grab attention, tell your story, connect deeply with your target audience, and make your message impossible to ignore.",
      image: "https://placehold.co/600x400?text=Graphic+Design",
      alt: "Graphic design elements",
    },
    {
      title: "Startup Branding",
      description:
        "Your startup must make a strong first impression to attract investors and customers. A distinctive brand sets your business apart from the competition. Let us create a brand that tells your story and positions you for growth in a competitive market.",
      image: "https://placehold.co/600x400?text=Startup+Branding",
      alt: "Startup branding elements",
    },
  ];
  const [expandedItem, setExpandedItem] = React.useState(null);

 const items = [
                { title: "Technology", details: "Details about Technology industry." },
                { title: "Healthcare", details: "Details about Healthcare industry." },
                { title: "Finance", details: "Details about Finance industry." },
                { title: "Consumer Goods", details: "Details about Consumer Goods industry." },
                { title: "Automotive", details: "Details about Automotive industry." },
                { title: "SaaS", details: "Details about SaaS industry." },
                { title: "Fashion and Apparel", details: "Details about Fashion and Apparel industry." },
                { title: "Beauty and Cosmetics", details: "Details about Beauty and Cosmetics industry." },
                { title: "Hospitality", details: "Details about Hospitality industry." },
                { title: "Cybersecurity", details: "Details about Cybersecurity industry." },
                { title: "Branding for Startups", details: "Details about Branding for Startups industry." },
                { title: "Non-profit", details: "Details about Non-profit industry." }
            ];


           
 const toggleItem = (index) => {
                setExpandedItem(expandedItem === index ? null : index);
};

    

  const [currentStep, setCurrentStep] = useState(0);

  const nextStep = () => {
    setCurrentStep((prevStep) => (prevStep + 1) % steps.length);
  };

  const prevStep = () => {
    setCurrentStep((prevStep) => (prevStep - 1 + steps.length) % steps.length);
  };
  return (
    <div className="mt-20">
      <section className="bg-black text-white text-center py-20 px-4 mt-4 ">
        <h1 className="text-4xl font-bold mb-4">
          Brand Design & Consulting Services
        </h1>
        <p className="text-lg mb-8">
          Is your brand failing to make an impact? Don't let poor design hold
          you back. Without professional brand design, you're leaving money on
          the table. We craft unique brand designs that capture attention, build
          trust, and turn browsers into buyers.
        </p>
        <button className="bg-yellow-400 text-black font-bold py-2 px-6 rounded-full">
          Let’s Craft Your Brand!
        </button>
      </section>
      <section className="bg-gray-100 py-10">
        <div className="text-center mb-6">
          <h2 className="text-lg font-bold">TRUSTED BY 200+ GLOBAL BRANDS</h2>
        </div>
        <div className="marquee">
          <img
            src="https://placehold.co/100x50"
            alt="i-payout logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Nuport logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Flaunte logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Microsoft logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="The Motley Fool logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Packt logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Indeed logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="daXtra logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="On Deck logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Peel logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Recharge logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Abyan Capital logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Wokelo.ai logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="eAssist logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Divine Home logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Panther logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Helpful logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="CIS logo"
            className="mx-4"
          />
          <img
            src="https://placehold.co/100x50"
            alt="Lingxing logo"
            className="mx-4"
          />
        </div>
      </section>
      <div className="flex justify-center items-center mt-5">
        <div className="flex flex-col md:flex-row items-center w-1/2">
          <div className="grid grid-cols-3 gap-4 p-4 bg-black rounded-lg">
            <img
              src="https://placehold.co/150x150"
              alt="Brainvoy logo"
              className="col-span-1 rounded-lg"
            />
            <img
              src="https://placehold.co/150x150"
              alt="Brainvoy icon"
              className="col-span-1 rounded-lg"
            />
            <img
              src="https://placehold.co/150x150"
              alt="Settings icon"
              className="col-span-1 rounded-lg"
            />
            <img
              src="https://placehold.co/150x150"
              alt="Browser window with Brainvoy"
              className="col-span-1 rounded-lg"
            />
            <img
              src="https://placehold.co/150x150"
              alt="Brainvoy logo"
              className="col-span-1 rounded-lg"
            />
            <img
              src="https://placehold.co/150x150"
              alt="Settings icon"
              className="col-span-1 rounded-lg"
            />
            <img
              src="https://placehold.co/150x150"
              alt="Brainvoy icon"
              className="col-span-1 rounded-lg"
            />
            <img
              src="https://placehold.co/150x150"
              alt="Settings icon"
              className="col-span-1 rounded-lg"
            />
            <img
              src="https://placehold.co/150x150"
              alt="Color palette"
              className="col-span-1 rounded-lg"
            />
          </div>
          <div className="ml-0 md:ml-8 mt-8 md:mt-0 text-center md:text-left">
            <h1 className="text-4xl font-bold text-black">
              Design Speaks Louder Than Words
            </h1>
            <p className="text-gray-700 mt-4">
              Your brand's design speaks before you do. 80% of consumers
              recognize a brand just by its design & color! We use color
              psychology to design your brand to be memorable.
            </p>
            <button className="mt-6 px-6 py-3 bg-black text-white rounded-full font-bold">
              Create Your Brand Identity!
            </button>
          </div>
        </div>
      </div>
      <div className="p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-4">
            Let's Walk You Through Our Brand Design Process
          </h1>
          <p className="text-lg mb-6">
            The process of branding and design follows a certain chronological
            order.
          </p>
          <button className="bg-yellow-400 text-black font-bold py-2 px-4 rounded-full">
            Begin Your Branding Journey
          </button>
        </div>
        <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-4">
          <button onClick={prevStep} className="bg-yellow-400 p-2 rounded-full">
            <i className="fas fa-arrow-left text-black"></i>
          </button>
          <div
            className={`p-6 rounded-lg shadow-md w-full md:w-1/5 ${steps[currentStep].bgColor}`}
          >
            <h2 className="text-lg font-bold mb-2">
              {steps[currentStep].title}
            </h2>
            <p className="text-sm">{steps[currentStep].description}</p>
          </div>
          <button onClick={nextStep} className="bg-yellow-400 p-2 rounded-full">
            <i className="fas fa-arrow-right text-black"></i>
          </button>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center space-y-6 md:space-y-0 md:space-x-12 p-6">
        <div className="text-center md:text-left max-w-md">
          <h1 className="text-4xl font-bold text-black">
            Brand Design Services
          </h1>
          <p className="text-gray-700 mt-4">
            Brand design services help create your brand's visual identity.
            These services include designing logos, choosing colors and fonts,
            and creating graphics representing your brand. This helps make your
            brand recognizable and memorable to customers.
          </p>
          <p className="text-gray-700 mt-4">
            We help you create a cohesive brand design that resonates with your
            audience, builds trust, and drives growth.
          </p>
          <button className="mt-6 px-6 py-3 bg-black text-white rounded-full text-lg">
            Create Your Brand Identity!
          </button>
        </div>
        <div className="flex justify-center">
          <img
            src="https://placehold.co/600x400"
            alt="Billboard with a woman holding a phone and text 'Track Your Pregnancy Journey' on it"
            className="w-full md:w-auto rounded-lg shadow-lg"
          ></img>
        </div>
      </div>
      <div className="container mx-auto p-4 md:w-10/20">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Range of Brand Design Services We Offer
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service, index) => (
            <div key={index} className="border p-4 rounded-lg shadow-md">
              <img
                src={service.image}
                alt={service.alt}
                className="w-full h-40 object-cover mb-4 rounded"
              />
              <h2 className="text-lg font-bold text-green-600 mb-2">
                {service.title}
              </h2>
              <p className="text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center items-center min-h-screen">
                    <div className="max-w-4xl w-full p-8">
                        <div className="mb-8">
                            <h1 className="text-4xl font-bold mb-4">From Tech to Retail: Tailored Brand Design for Every Industry</h1>
                            <p className="text-lg mb-6">We provide cutting-edge brand design services across various industries, including:</p>
                            <button className="bg-black text-white py-2 px-4 rounded">Create Your Brand Identity!</button>
                        </div>
                        <div className="space-y-4">
                            {items.map((item, index) => (
                                <div key={index}>
                                    <div 
                                        className="flex justify-between items-center border-b border-gray-400 py-2 cursor-pointer"
                                        onClick={() => toggleItem(index)}
                                    >
                                        <span>{item.title}</span>
                                        <i className={`fas fa-chevron-${expandedItem === index ? 'up' : 'down'}`}></i>
                                    </div>
                                    {expandedItem === index && (
                                        <div className="p-4 bg-gray-200">
                                            {item.details}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className=" min-h-screen flex flex-col items-center">
                    
                    <div className="bg-white w-full max-w-6xl p-8 text-center mt-7">
                        <h1 className="text-2xl font-bold mb-8">Why Brand Design Matters for Your Business</h1>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                            <div className="flex flex-col items-center">
                                <i className="fas fa-star text-4xl mb-4"></i>
                                <h2 className="font-bold">Get Noticed Quickly:</h2>
                                <p className="text-gray-600">Your brand can stand out from the competition with our one-of-a-kind visual identity. Customers will remember you, not the generic brand next door.</p>
                            </div>
                            <div className="flex flex-col items-center">
                                <i className="fas fa-bullseye text-4xl mb-4"></i>
                                <h2 className="font-bold">Attract Your Target Audience:</h2>
                                <p className="text-gray-600">Your brand design attracts customers aligned with your values and products, so no chasing the wrong crowd anymore.</p>
                            </div>
                            <div className="flex flex-col items-center">
                                <i className="fas fa-handshake text-4xl mb-4"></i>
                                <h2 className="font-bold">Build Trust & Credibility:</h2>
                                <p className="text-gray-600">Professional design promotes authority and trustworthiness, and the customer will see you as a leader in the industry.</p>
                            </div>
                            <div className="flex flex-col items-center">
                                <i className="fas fa-leaf text-4xl mb-4"></i>
                                <h2 className="font-bold">Create Lasting Impact:</h2>
                                <p className="text-gray-600">Every interaction with your brand, from website to packaging, tells a powerful story that leaves a lasting impression.</p>
                            </div>
                            <div className="flex flex-col items-center">
                                <i className="fas fa-chart-line text-4xl mb-4"></i>
                                <h2 className="font-bold">Boost Brand Value & ROI:</h2>
                                <p className="text-gray-600">Strong design isn't just an expense; it's an investment that increases customer loyalty and drives sales and profitability.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col justify-center  items-center py-2 ">
                    <h1 className="text-2xl font-bold mb-0">Our Brand Design Success Stories</h1>
                    <div className="grid grid-cols-2 gap-4 md:w-1/2">
                        <div className="bg-yellow-400 p-8">
                            <h2 className="text-5xl font-bold">60%</h2>
                            <p className="mt-4">Boosted 60% engagement for clients like you</p>
                        </div>
                        <div className="bg-white text-black p-8">
                            <h2 className="text-5xl font-bold">40%</h2>
                            <p className="mt-4">Whopping 40% increase in customer retention</p>
                        </div>
                        <div className="bg-green-400 p-8">
                            <h2 className="text-5xl font-bold">2M</h2>
                            <p className="mt-4">Achieved 2M funding during seed investment</p>
                        </div>
                        <div className="bg-gray-100 text-black p-8 flex flex-col justify-between">
                            <div>
                                <h2 className="text-xl font-bold">Kiddie</h2>
                                <p className="mt-2">Kiddie - Pregnancy and Period Tracker App</p>
                            </div>
                            <div className="mt-4">
                                <img src="https://placehold.co/300x150" alt="Kiddie app screenshots" className="w-full"/>
                                <button className="mt-4 bg-yellow-400 text-black px-4 py-2">See Kiddie case study</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center">
                    <div className="w-full h-16"></div>
                    <div className="flex flex-col items-center w-full">
                        <div className="flex flex-col md:flex-row items-center justify-between w-11/12 md:w-10/12 lg:w-8/12 my-16">
                            <div className="md:w-1/2">
                                <h1 className="text-3xl md:text-4xl font-bold mb-4">Let's Ditch the Generic!<br />Why Choose Musemind?</h1>
                                <p className="text-gray-600 mb-4">
                                    At Musemind, We take a detail-oriented approach, conducting in-depth research and analysis to understand your industry, target audience, and competitors, ensuring that your brand stands out in a crowded market.
                                </p>
                                <h2 className="text-lg font-semibold mb-2">Choose Musemind for:</h2>
                                <ul className="list-disc list-inside text-gray-600 mb-4">
                                    <li>Proven track record with over 200 global brands.</li>
                                    <li>From logos to full comprehensive brand identity.</li>
                                    <li>Innovative approach using the latest technology.</li>
                                    <li>Expert designers with deep market knowledge.</li>
                                    <li>Seamless strategy and execution process.</li>
                                    <li>Personalized solutions based on client needs.</li>
                                </ul>
                                <button className="bg-black text-white py-2 px-4 rounded-full">Get Started with Musemind!</button>
                            </div>
                            <div className="md:w-1/2 mt-8 md:mt-0">
                                <img src="https://placehold.co/600x400" alt="PixelSwap advertisement in a subway station" className="w-full rounded-lg shadow-lg" />
                            </div>
                        </div>
                    </div>
                
                </div>
               
                   
    </div>
  );
}
